import { Placeholder } from 'modules/common/components/Placeholder';
import { useFetchReferralProgramsQuery } from 'modules/strapi/actions/fetchReferralPrograms';

export interface ReferralProgramsProviderProps {
  children: React.ReactNode;
}

export const ReferralProgramsProvider = ({
  children,
}: ReferralProgramsProviderProps) => {
  const { data } = useFetchReferralProgramsQuery();
  const isLoaded = data !== undefined;

  return (
    <Placeholder hasPlaceholder={!isLoaded} placeholder={null}>
      {children}
    </Placeholder>
  );
};
